import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class SiteVisitService {

  private url = `${environment.serverAPI9}/api/property/site-visits`;

  constructor(private http: HttpClient,
  ) { }



  createSiteVisit(siteVisit: any): Observable<any> {
    return this.http.post<any>(this.url, siteVisit);
  }

  checkInSiteVisit(siteVisitId: number, lat: number, lng: number): Observable<any> {
    const checkInUrl = `${this.url}/${siteVisitId}/check-in`;
    return this.http.post<any>(checkInUrl, { latitude: lat, longitude: lng });
  }

  getAllSiteVisits(): Observable<any> {
    return this.http.get<any>(this.url);
  }

  getSiteVisitById(siteVisitId: number): Observable<any> {
    return this.http.get<any>(`${this.url}/${siteVisitId}`);
  }

  getSiteVisitsByLeadId(leadId: number): Observable<any> {
    return this.http.get<any>(`${this.url}/lead/${leadId}`);
  }

  getSiteVisitsByAgentId(agentId: number | string): Observable<any> {
    return this.http.get<any>(`${this.url}/agent/${agentId}`);
  }

  getSiteVisitsBySalesPersonId(agentId: number | string): Observable<any> {
    return this.http.get<any>(`${this.url}/agent/sales/${agentId}`);
  }
}
